import * as React from "react";
import type { SVGProps } from "react";
const ElbowedLineIcon = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="none" style={{
  userSelect: "none",
  flexShrink: 0
}} {...props}><path fill="currentColor" fillRule="evenodd" d="M11.25 7A2.75 2.75 0 0 1 14 4.25h7a.75.75 0 0 1 0 1.5h-7c-.69 0-1.25.56-1.25 1.25v10A2.75 2.75 0 0 1 10 19.75H3a.75.75 0 0 1 0-1.5h7c.69 0 1.25-.56 1.25-1.25z" clipRule="evenodd" /></svg>;
export default ElbowedLineIcon;